import React from 'react';
import { X, Save, Loader2, CheckCircle2 } from 'lucide-react';
import { useViewport } from '../hooks/useViewport';

interface ModalProps {
  title: string;
  onClose: () => void;
  onSubmit: (e: React.FormEvent) => void;
  loading?: boolean;
  isEdit?: boolean;
  children: React.ReactNode;
  wide?: boolean;
  error?: string | null;
  isOpen?: boolean;
  submitLabel?: string;
  submitDisabled?: boolean;
  submitDanger?: boolean;
}

export function Modal({ title, onClose, onSubmit, loading, isEdit, children, wide, error, isOpen, submitLabel, submitDisabled, submitDanger }: ModalProps) {
  const { isPhone } = useViewport();
  if (isOpen === false) return null;
  const btnLabel = submitLabel ?? (isEdit ? 'Сохранить' : 'Создать');
  const useSaveIcon = submitLabel == null;
  const SubmitIcon = useSaveIcon ? Save : CheckCircle2;
  return (
    <div className={`modal-overlay${isPhone ? ' modal-overlay--sheet' : ''}`}>
      <div
        className={`modal${isPhone ? ' modal--sheet' : ''}${wide ? ' modal--wide' : ''}`}
        style={isPhone ? undefined : { maxWidth: wide ? '1200px' : '600px' }}
        onClick={e => e.stopPropagation()}
        data-testid="modal"
      >
        <div className="modal-header">
          <h2>{title}</h2>
          <button className="btn-icon" onClick={onClose} disabled={loading}><X size={20} /></button>
        </div>
        <form onSubmit={onSubmit}>
          <div className="modal-scroll" style={{ padding: '1.5rem' }}>
            {error && <div className="error-banner" style={{ marginBottom: '1rem' }}>{error}</div>}
            {children}
          </div>
          <div className="form-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>Отмена</button>
            {submitLabel !== '' && (
              <button type="submit" className={`btn ${submitDanger ? 'btn-danger' : 'btn-primary'}`} disabled={loading || submitDisabled}>
                {loading
                  ? <><Loader2 size={15} className="spin" /> Сохранение...</>
                  : <><SubmitIcon size={15} /> {btnLabel}</>
                }
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}
